export class Unidade {
  constructor({ id, nome, logo, codigoIntegracaoUnidade, endereco }) {
    this.id = id;
    this.nome = nome;
    this.logo = logo;
    this.codigoIntegracaoUnidade = codigoIntegracaoUnidade;
    this.endereco = endereco;
  }
}
